// assets
import { ReactComponent as Trillion } from '../assets/navigation-icons/trillion.svg';


// icons
const icons = {
    Trillion
};

export const getTrillionItems = (token) => {
    // Build dynamic Trillion URL that includes the logged-in user's email (if available)

    const trillionUrl = `https://trillion.boxphish.com/sso/callback?login&token=${encodeURIComponent(token)}`;

    // ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //
    
    return {
        id: 'trillionItems',
        type: 'group',
        title: 'Trillion',
        divider: true,
        children: [
            {
                id: 'trillion',
                title: 'Dark Web Monitoring',
                type: 'item',
                url: trillionUrl,
                icon: icons.Trillion,
                disabled: false,
                target: "_blank"
            },
        ]
    };

}
